import React, { useEffect, useState } from "react";
import images from "../../../themes/appImage";
import { useDispatch, useSelector } from "react-redux";
import {
  encouragementPostListLoad,
  encouragementPostListEmpty,
  encouragementRenderPostListLoad,
} from "../../../redux/slices/encouragementgroups.slice";
import EncouragementPost from "./EncouragmentPost";
import Loader from "../../global-components/loader";
import { imageURL } from "../../../redux/Api/apikit";

const apiPayloadInit = {
  offset: 0,
  limit: 10,
};

const EncouragementPosts = ({ myid }) => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.EncouragementgroupsReducer);
  const [apiPayload, setApiPayload] = useState(apiPayloadInit);
  const {
    encouragementPostListRenderData,
    encouragementPostListData,
    postCreatedSuccess,
  } = useSelector((state) => state.EncouragementgroupsReducer);

  const { removePostPass, isPostLikeSuccess } = useSelector(
    (state) => state.CommunityReducer
  );

  useEffect(() => {
    const data = {
      ...apiPayload,
      group: myid,
    };
    dispatch(encouragementPostListLoad(data));
    return () => {
      dispatch(encouragementPostListEmpty());
    };
  }, []);

  useEffect(() => {
    const data = {
      offset: 0,
      limit: 10,
      group: myid,
    };
    if (postCreatedSuccess) {
      setApiPayload(apiPayloadInit);
      dispatch(encouragementPostListLoad(data));
    }
  }, [postCreatedSuccess]);

  //   const data = {
  //     ...apiPayload,
  //     group: myid
  //   };
  //   if (isPostLikeSuccess)

  //     dispatch(encouragementPostListLoad(data));
  // }, [ isPostLikeSuccess]);

  // useEffect(() => {
  //   const data = {
  //     ...apiPayload,
  //     group: myid
  //   };
  //   if (removePostPass || isPostLikeSuccess)
  //   {
  //     console.log("working")
  //   dispatch(encouragementPostListLoad(data));
  //   }
  // }, [removePostPass, isPostLikeSuccess]);

  useEffect(() => {
    console.log(encouragementPostListData, "dka");
    dispatch(
      encouragementRenderPostListLoad([
        ...encouragementPostListRenderData,
        ...encouragementPostListData,
      ])
    );
  }, [encouragementPostListData]);

  const handlerShowMoreCommentsHandler = () => {
    const updateOffset = apiPayload.offset + apiPayload.limit;
    const data = {
      ...apiPayload,
      offset: updateOffset,
      group: myid,
    };
    dispatch(encouragementPostListLoad(data));
    setApiPayload((pre) => ({ ...pre, offset: updateOffset }));
  };

  return (
    <div>
      {loading ? (
        <div className="mt-3">
          <Loader />
        </div>
      ) : (
        <>
          <div className="flex flex-col gap-4 mt-4">
            {encouragementPostListRenderData &&
            encouragementPostListRenderData?.length > 0 ? (
              encouragementPostListRenderData?.map(
                (
                  {
                    text,
                    file,
                    postType,
                    createdAt,
                    createdByAdmin,
                    happyFace,
                    partyFace,
                    creatorData,
                    redHeart,
                    smileyFace,
                    smileyHeart,
                    comment,
                    _id,
                  },
                  key
                ) => (
                  <EncouragementPost
                    key={key}
                    avatarSrc={
                      createdByAdmin
                        ? images.matleFitLogo
                        : creatorData?.avatar
                        ? `${imageURL}${creatorData?.avatar}`
                        : images.defaultAvatar
                    }
                    username={
                      createdByAdmin ? "mentalfit" : creatorData?.userName
                    }
                    time={createdAt}
                    description={text}
                    file={file}
                    postType={postType}
                    coverSrc={images.cardCover}
                    commentSrc={images.commentImg}
                    hugSrc={images.hug}
                    happyFace={happyFace}
                    partyFace={partyFace}
                    redHeart={redHeart}
                    smileyFace={smileyFace}
                    smileyHeart={smileyHeart}
                    comment={comment}
                    id={_id}
                  />
                )
              )
            ) : (
              <div className="text-base font-medium w-full text-center mt-5">
                No Posts
              </div>
            )}
          </div>
          {encouragementPostListRenderData?.length >= apiPayload.limit && (
            <div className=" flex mt-3 justify-center">
              <div
                onClick={handlerShowMoreCommentsHandler}
                className="cursor-pointer border border-black rounded-md p-1 px-2 text-sm text-black"
              >
                Show more
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default EncouragementPosts;
